import { db, auth, timestamp } from '@/firebaseConfig'
import { goToPath } from '../../mixins'

export default {
  state: { spa: null, admins: [] },
  mutations: {
    setSpa(state, spa) {
      state.spa = spa
    },
    addAdmin(state, admin) {
      state.admins.push(admin)
    },
    setAdmins(state, admins) {
      state.admins = admins
    },
    clearSpa(state) {
      state.spa = null
    },
    deleteAdmin(state, admin) {
      const index = state.admins.indexOf(admin)
      state.admins.splice(index, 1)
    }
  },
  actions: {
    loginSpa({ commit }, spa) {
      auth.signInWithEmailAndPassword(spa.email, spa.password)
        .then((data) => {
          const spaPath = `spa/${data.user.uid}`
          db.doc(spaPath).get()
            .then((snapshot) => {
              const spaData = snapshot.data()
              commit('setSpa', spaData)
              goToPath('/manager')
              /**
               * Check if displayName is set and set it if not
               */
              if (!data.user.displayName) {
                data.user.updateProfile({ displayName: 'spa' })
              }
            })
        })
    },
    logoutSpa({ commit }) {
      auth.signOut()
      commit('clearSpa')
    },
    loadAdmins({ commit }) {
      return new Promise((resolve, reject) => {
        const adminsRef = db.collection('admins')
        // TODO: limit admins to 1O for the first query(.limit(10))
        const admins = adminsRef.orderBy('createdAt', 'desc')
        admins.get()
          .then(async(snapshot) => {
            const admins = []
            snapshot.forEach((doc) => {
              admins.push(doc.data())
            })

            await commit('setAdmins', admins)
            resolve()
          })
          .catch((err) => reject(err))
      })
    },
    createAdmin({ commit }, admin) {
      // If you want to write a rule that requires that client apps must send the server timestamp token in the createdAt field on all writes to documents in the messages collection, you simply use this:
      // Security rule example match /messages/{id} {
      //   allow write: if request.resource.data.createdAt == request.time;
      // }
      // servertime
      return new Promise((resolve, reject) => {
        const newAdminRef = db.collection('admins').doc()
        const newAdmin = {
          ...admin,
          id: newAdminRef.id,
          isAccountVerified: false,
          createdAt: timestamp,
          updatedAt: timestamp,
          creationError: '',
          isAdmin: true
        }
        db.doc(`/admins/${newAdmin.id}`)
          .set(newAdmin)
          .then(() => {
            // Add supplier to local store(state)
            commit('addAdmin', newAdmin)
            resolve('admin added successfuly')
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    deleteAdmin({ commit }, admin) {
      return new Promise((resolve, reject) => {
        // Deleting admin: just the account, don't
        const docRef = db.doc(`/admins/${admin.id}`)
        docRef
          .delete()
          .then(() => {
            commit('deleteAdmin', admin)
            resolve()
          })
          .catch((err) => reject(err))
      })
    }
  },
  getters: {
    admins(state) {
      return state.admins
    }
  }
}
